import { render, staticRenderFns } from "./PartCkuPrvsPopup.vue?vue&type=template&id=8794db40&"
import script from "./PartCkuPrvsPopup.vue?vue&type=script&lang=js&"
export * from "./PartCkuPrvsPopup.vue?vue&type=script&lang=js&"
import style0 from "./PartCkuPrvsPopup.vue?vue&type=style&index=0&id=8794db40&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports